var country = [
    {
        "Code2": "AL",
        "Code3": "ALB",
        "Num": "8",
        "Iso": "ISO 3166-2:AL",
        "ENName": "Albania",
        "CNName": "阿尔巴尼亚"
    },
    {
        "Code2": "DZ",
        "Code3": "DZA",
        "Num": "12",
        "Iso": "ISO 3166-2:DZ",
        "ENName": "Algeria",
        "CNName": "阿尔及利亚"
    },
    {
        "Code2": "AF",
        "Code3": "AFG",
        "Num": "4",
        "Iso": "ISO 3166-2:AF",
        "ENName": "Afghanistan",
        "CNName": "阿富汗"
    },
    {
        "Code2": "AR",
        "Code3": "ARG",
        "Num": "32",
        "Iso": "ISO 3166-2:AR",
        "ENName": "Argentina",
        "CNName": "阿根廷"
    },
    {
        "Code2": "AE",
        "Code3": "ARE",
        "Num": "784",
        "Iso": "ISO 3166-2:AE",
        "ENName": "United Arab Emirates",
        "CNName": "阿联酋"
    },
    {
        "Code2": "AW",
        "Code3": "ABW",
        "Num": "533",
        "Iso": "ISO 3166-2:AW",
        "ENName": "Aruba",
        "CNName": "阿鲁巴"
    },
    {
        "Code2": "OM",
        "Code3": "OMN",
        "Num": "512",
        "Iso": "ISO 3166-2:OM",
        "ENName": "Oman",
        "CNName": "阿曼"
    },
    {
        "Code2": "AZ",
        "Code3": "AZE",
        "Num": "31",
        "Iso": "ISO 3166-2:AZ",
        "ENName": "Azerbaijan",
        "CNName": "阿塞拜疆"
    },
    {
        "Code2": "EG",
        "Code3": "EGY",
        "Num": "818",
        "Iso": "ISO 3166-2:EG",
        "ENName": "Egypt",
        "CNName": "埃及"
    },
    {
        "Code2": "ET",
        "Code3": "ETH",
        "Num": "231",
        "Iso": "ISO 3166-2:ET",
        "ENName": "Ethiopia",
        "CNName": "埃塞俄比亚"
    },
    {
        "Code2": "IE",
        "Code3": "IRL",
        "Num": "372",
        "Iso": "ISO 3166-2:IE",
        "ENName": "Ireland",
        "CNName": "爱尔兰"
    },
    {
        "Code2": "EE",
        "Code3": "EST",
        "Num": "233",
        "Iso": "ISO 3166-2:EE",
        "ENName": "Estonia",
        "CNName": "爱沙尼亚"
    },
    {
        "Code2": "AD",
        "Code3": "AND",
        "Num": "20",
        "Iso": "ISO 3166-2:AD",
        "ENName": "Andorra",
        "CNName": "安道尔"
    },
    {
        "Code2": "AO",
        "Code3": "AGO",
        "Num": "24",
        "Iso": "ISO 3166-2:AO",
        "ENName": "Angola",
        "CNName": "安哥拉"
    },
    {
        "Code2": "AI",
        "Code3": "AIA",
        "Num": "660",
        "Iso": "ISO 3166-2:AI",
        "ENName": "Anguilla",
        "CNName": "安圭拉"
    },
    {
        "Code2": "AG",
        "Code3": "ATG",
        "Num": "28",
        "Iso": "ISO 3166-2:AG",
        "ENName": "Antigua & Barbuda",
        "CNName": "安提瓜和巴布达"
    },
    {
        "Code2": "AT",
        "Code3": "AUT",
        "Num": "40",
        "Iso": "ISO 3166-2:AT",
        "ENName": "Austria",
        "CNName": "奥地利"
    },
    {
        "Code2": "AX",
        "Code3": "ALA",
        "Num": "248",
        "Iso": "ISO 3166-2:AX",
        "ENName": "?aland Island",
        "CNName": "奥兰群岛"
    },
    {
        "Code2": "AU",
        "Code3": "AUS",
        "Num": "36",
        "Iso": "ISO 3166-2:AU",
        "ENName": "Australia",
        "CNName": "澳大利亚"
    },
    {
        "Code2": "BB",
        "Code3": "BRB",
        "Num": "52",
        "Iso": "ISO 3166-2:BB",
        "ENName": "Barbados",
        "CNName": "巴巴多斯"
    },
    {
        "Code2": "PG",
        "Code3": "PNG",
        "Num": "598",
        "Iso": "ISO 3166-2:PG",
        "ENName": "Papua New Guinea",
        "CNName": "巴布亚新几内亚"
    },
    {
        "Code2": "BS",
        "Code3": "BHS",
        "Num": "44",
        "Iso": "ISO 3166-2:BS",
        "ENName": "The Bahamas",
        "CNName": "巴哈马"
    },
    {
        "Code2": "PK",
        "Code3": "PAK",
        "Num": "586",
        "Iso": "ISO 3166-2:PK",
        "ENName": "Pakistan",
        "CNName": "巴基斯坦"
    },
    {
        "Code2": "PY",
        "Code3": "PRY",
        "Num": "600",
        "Iso": "ISO 3166-2:PY",
        "ENName": "Paraguay",
        "CNName": "巴拉圭"
    },
    {
        "Code2": "PS",
        "Code3": "PSE",
        "Num": "275",
        "Iso": "ISO 3166-2:PS",
        "ENName": "Palestinian territories",
        "CNName": "巴勒斯坦"
    },
    {
        "Code2": "BH",
        "Code3": "BHR",
        "Num": "48",
        "Iso": "ISO 3166-2:BH",
        "ENName": "Bahrain",
        "CNName": "巴林"
    },
    {
        "Code2": "PA",
        "Code3": "PAN",
        "Num": "591",
        "Iso": "ISO 3166-2:PA",
        "ENName": "Panama",
        "CNName": "巴拿马"
    },
    {
        "Code2": "BR",
        "Code3": "BRA",
        "Num": "76",
        "Iso": "ISO 3166-2:BR",
        "ENName": "Brazil",
        "CNName": "巴西"
    },
    {
        "Code2": "BY",
        "Code3": "BLR",
        "Num": "112",
        "Iso": "ISO 3166-2:BY",
        "ENName": "Belarus",
        "CNName": "白俄罗斯"
    },
    {
        "Code2": "BM",
        "Code3": "BMU",
        "Num": "60",
        "Iso": "ISO 3166-2:BM",
        "ENName": "Bermuda",
        "CNName": "百慕大"
    },
    {
        "Code2": "BG",
        "Code3": "BGR",
        "Num": "100",
        "Iso": "ISO 3166-2:BG",
        "ENName": "Bulgaria",
        "CNName": "保加利亚"
    },
    {
        "Code2": "MP",
        "Code3": "MNP",
        "Num": "580",
        "Iso": "ISO 3166-2:MP",
        "ENName": "Northern Mariana Islands",
        "CNName": "北马里亚纳群岛"
    },
    {
        "Code2": "BJ",
        "Code3": "BEN",
        "Num": "204",
        "Iso": "ISO 3166-2:BJ",
        "ENName": "Benin",
        "CNName": "贝宁"
    },
    {
        "Code2": "BE",
        "Code3": "BEL",
        "Num": "56",
        "Iso": "ISO 3166-2:BE",
        "ENName": "Belgium",
        "CNName": "比利时"
    },
    {
        "Code2": "IS",
        "Code3": "ISL",
        "Num": "352",
        "Iso": "ISO 3166-2:IS",
        "ENName": "Iceland",
        "CNName": "冰岛"
    },
    {
        "Code2": "PR",
        "Code3": "PRI",
        "Num": "630",
        "Iso": "ISO 3166-2:PR",
        "ENName": "Puerto Rico",
        "CNName": "波多黎各"
    },
    {
        "Code2": "BA",
        "Code3": "BIH",
        "Num": "70",
        "Iso": "ISO 3166-2:BA",
        "ENName": "Bosnia & Herzegovina",
        "CNName": "波黑"
    },
    {
        "Code2": "PL",
        "Code3": "POL",
        "Num": "616",
        "Iso": "ISO 3166-2:PL",
        "ENName": "Poland",
        "CNName": "波兰"
    },
    {
        "Code2": "BO",
        "Code3": "BOL",
        "Num": "68",
        "Iso": "ISO 3166-2:BO",
        "ENName": "Bolivia",
        "CNName": "玻利维亚"
    },
    {
        "Code2": "BZ",
        "Code3": "BLZ",
        "Num": "84",
        "Iso": "ISO 3166-2:BZ",
        "ENName": "Belize",
        "CNName": "伯利兹"
    },
    {
        "Code2": "BW",
        "Code3": "BWA",
        "Num": "72",
        "Iso": "ISO 3166-2:BW",
        "ENName": "Botswana",
        "CNName": "博茨瓦纳"
    },
    {
        "Code2": "BT",
        "Code3": "BTN",
        "Num": "64",
        "Iso": "ISO 3166-2:BT",
        "ENName": "Bhutan",
        "CNName": "不丹"
    },
    {
        "Code2": "BF",
        "Code3": "BFA",
        "Num": "854",
        "Iso": "ISO 3166-2:BF",
        "ENName": "Burkina",
        "CNName": "布基纳法索"
    },
    {
        "Code2": "BI",
        "Code3": "BDI",
        "Num": "108",
        "Iso": "ISO 3166-2:BI",
        "ENName": "Burundi",
        "CNName": "布隆迪"
    },
    {
        "Code2": "BV",
        "Code3": "BVT",
        "Num": "74",
        "Iso": "ISO 3166-2:BV",
        "ENName": "Bouvet Island",
        "CNName": "布韦岛"
    },
    {
        "Code2": "KP",
        "Code3": "PRK",
        "Num": "408",
        "Iso": "ISO 3166-2:KP",
        "ENName": "North Korea",
        "CNName": "朝鲜 北朝鲜"
    },
    {
        "Code2": "GQ",
        "Code3": "GNQ",
        "Num": "226",
        "Iso": "ISO 3166-2:GQ",
        "ENName": "Equatorial Guinea",
        "CNName": "赤道几内亚"
    },
    {
        "Code2": "DK",
        "Code3": "DNK",
        "Num": "208",
        "Iso": "ISO 3166-2:DK",
        "ENName": "Denmark",
        "CNName": "丹麦"
    },
    {
        "Code2": "DE",
        "Code3": "DEU",
        "Num": "276",
        "Iso": "ISO 3166-2:DE",
        "ENName": "Germany",
        "CNName": "德国"
    },
    {
        "Code2": "TL",
        "Code3": "TLS",
        "Num": "626",
        "Iso": "ISO 3166-2:TP",
        "ENName": "Timor-Leste (East Timor)",
        "CNName": "东帝汶"
    },
    {
        "Code2": "TG",
        "Code3": "TGO",
        "Num": "768",
        "Iso": "ISO 3166-2:TG",
        "ENName": "Togo",
        "CNName": "多哥"
    },
    {
        "Code2": "DO",
        "Code3": "DOM",
        "Num": "214",
        "Iso": "ISO 3166-2:DO",
        "ENName": "Dominican Republic",
        "CNName": "多米尼加"
    },
    {
        "Code2": "DM",
        "Code3": "DMA",
        "Num": "212",
        "Iso": "ISO 3166-2:DM",
        "ENName": "Dominica",
        "CNName": "多米尼克"
    },
    {
        "Code2": "RU",
        "Code3": "RUS",
        "Num": "643",
        "Iso": "ISO 3166-2:RU",
        "ENName": "Russian Federation",
        "CNName": "俄罗斯"
    },
    {
        "Code2": "EC",
        "Code3": "ECU",
        "Num": "218",
        "Iso": "ISO 3166-2:EC",
        "ENName": "Ecuador",
        "CNName": "厄瓜多尔"
    },
    {
        "Code2": "ER",
        "Code3": "ERI",
        "Num": "232",
        "Iso": "ISO 3166-2:ER",
        "ENName": "Eritrea",
        "CNName": "厄立特里亚"
    },
    {
        "Code2": "FR",
        "Code3": "FRA",
        "Num": "250",
        "Iso": "ISO 3166-2:FR",
        "ENName": "France",
        "CNName": "法国"
    },
    {
        "Code2": "FO",
        "Code3": "FRO",
        "Num": "234",
        "Iso": "ISO 3166-2:FO",
        "ENName": "Faroe Islands",
        "CNName": "法罗群岛"
    },
    {
        "Code2": "PF",
        "Code3": "PYF",
        "Num": "258",
        "Iso": "ISO 3166-2:PF",
        "ENName": "French polynesia",
        "CNName": "法属波利尼西亚"
    },
    {
        "Code2": "GF",
        "Code3": "GUF",
        "Num": "254",
        "Iso": "ISO 3166-2:GF",
        "ENName": "French Guiana",
        "CNName": "法属圭亚那"
    },
    {
        "Code2": "TF",
        "Code3": "ATF",
        "Num": "260",
        "Iso": "ISO 3166-2:TF",
        "ENName": "French Southern Territories",
        "CNName": "法属南部领地"
    },
    {
        "Code2": "MF",
        "Code3": "MAF",
        "Num": "663",
        "Iso": "ISO 3166-2:MF",
        "ENName": "Saint Martin (France)",
        "CNName": "法属圣马丁"
    },
    {
        "Code2": "VA",
        "Code3": "VAT",
        "Num": "336",
        "Iso": "ISO 3166-2:VA",
        "ENName": "Vatican City (The Holy See)",
        "CNName": "梵蒂冈"
    },
    {
        "Code2": "PH",
        "Code3": "PHL",
        "Num": "608",
        "Iso": "ISO 3166-2:PH",
        "ENName": "The Philippines",
        "CNName": "菲律宾"
    },
    {
        "Code2": "FJ",
        "Code3": "FJI",
        "Num": "242",
        "Iso": "ISO 3166-2:FJ",
        "ENName": "Fiji",
        "CNName": "斐济群岛"
    },
    {
        "Code2": "FI",
        "Code3": "FIN",
        "Num": "246",
        "Iso": "ISO 3166-2:FI",
        "ENName": "Finland",
        "CNName": "芬兰"
    },
    {
        "Code2": "CV",
        "Code3": "CPV",
        "Num": "132",
        "Iso": "ISO 3166-2:CV",
        "ENName": "Cape Verde",
        "CNName": "佛得角"
    },
    {
        "Code2": "GM",
        "Code3": "GMB",
        "Num": "270",
        "Iso": "ISO 3166-2:GM",
        "ENName": "Gambia",
        "CNName": "冈比亚"
    },
    {
        "Code2": "CG",
        "Code3": "COG",
        "Num": "178",
        "Iso": "ISO 3166-2:CG",
        "ENName": "Republic of the Congo",
        "CNName": "刚果（布）"
    },
    {
        "Code2": "CD",
        "Code3": "COD",
        "Num": "180",
        "Iso": "ISO 3166-2:CD",
        "ENName": "Democratic Republic of the Congo",
        "CNName": "刚果（金）"
    },
    {
        "Code2": "CO",
        "Code3": "COL",
        "Num": "170",
        "Iso": "ISO 3166-2:CO",
        "ENName": "Colombia",
        "CNName": "哥伦比亚"
    },
    {
        "Code2": "CR",
        "Code3": "CRI",
        "Num": "188",
        "Iso": "ISO 3166-2:CR",
        "ENName": "Costa Rica",
        "CNName": "哥斯达黎加"
    },
    {
        "Code2": "GD",
        "Code3": "GRD",
        "Num": "308",
        "Iso": "ISO 3166-2:GD",
        "ENName": "Grenada",
        "CNName": "格林纳达"
    },
    {
        "Code2": "GL",
        "Code3": "GRL",
        "Num": "304",
        "Iso": "ISO 3166-2:GL",
        "ENName": "Greenland",
        "CNName": "格陵兰"
    },
    {
        "Code2": "GE",
        "Code3": "GEO",
        "Num": "268",
        "Iso": "ISO 3166-2:GE",
        "ENName": "Georgia",
        "CNName": "格鲁吉亚"
    },
    {
        "Code2": "GG",
        "Code3": "GGY",
        "Num": "831",
        "Iso": "ISO 3166-2:GG",
        "ENName": "Guernsey",
        "CNName": "根西岛"
    },
    {
        "Code2": "CU",
        "Code3": "CUB",
        "Num": "192",
        "Iso": "ISO 3166-2:CU",
        "ENName": "Cuba",
        "CNName": "古巴"
    },
    {
        "Code2": "GP",
        "Code3": "GLP",
        "Num": "312",
        "Iso": "ISO 3166-2:GP",
        "ENName": "Guadeloupe",
        "CNName": "瓜德罗普"
    },
    {
        "Code2": "GU",
        "Code3": "GUM",
        "Num": "316",
        "Iso": "ISO 3166-2:GU",
        "ENName": "Guam",
        "CNName": "关岛"
    },
    {
        "Code2": "GY",
        "Code3": "GUY",
        "Num": "328",
        "Iso": "ISO 3166-2:GY",
        "ENName": "Guyana",
        "CNName": "圭亚那"
    },
    {
        "Code2": "KZ",
        "Code3": "KAZ",
        "Num": "398",
        "Iso": "ISO 3166-2:KZ",
        "ENName": "Kazakhstan",
        "CNName": "哈萨克斯坦"
    },
    {
        "Code2": "HT",
        "Code3": "HTI",
        "Num": "332",
        "Iso": "ISO 3166-2:HT",
        "ENName": "Haiti",
        "CNName": "海地"
    },
    {
        "Code2": "KR",
        "Code3": "KOR",
        "Num": "410",
        "Iso": "ISO 3166-2:KR",
        "ENName": "South Korea",
        "CNName": "韩国 南朝鲜"
    },
    {
        "Code2": "NL",
        "Code3": "NLD",
        "Num": "528",
        "Iso": "ISO 3166-2:NL",
        "ENName": "Netherlands",
        "CNName": "荷兰"
    },
    {
        "Code2": "BQ",
        "Code3": "BES",
        "Num": "535",
        "Iso": "ISO 3166-2:BQ",
        "ENName": "Caribbean Netherlands",
        "CNName": "荷兰加勒比区"
    },
    {
        "Code2": "HM",
        "Code3": "HMD",
        "Num": "334",
        "Iso": "ISO 3166-2:HM",
        "ENName": "Heard Island and McDonald Islands",
        "CNName": "赫德岛和麦克唐纳群岛"
    },
    {
        "Code2": "ME",
        "Code3": "MNE",
        "Num": "499",
        "Iso": "ISO 3166-2:ME",
        "ENName": "Montenegro",
        "CNName": "黑山"
    },
    {
        "Code2": "HN",
        "Code3": "HND",
        "Num": "340",
        "Iso": "ISO 3166-2:HN",
        "ENName": "Honduras",
        "CNName": "洪都拉斯"
    },
    {
        "Code2": "KI",
        "Code3": "KIR",
        "Num": "296",
        "Iso": "ISO 3166-2:KI",
        "ENName": "Kiribati",
        "CNName": "基里巴斯"
    },
    {
        "Code2": "DJ",
        "Code3": "DJI",
        "Num": "262",
        "Iso": "ISO 3166-2:DJ",
        "ENName": "Djibouti",
        "CNName": "吉布提"
    },
    {
        "Code2": "KG",
        "Code3": "KGZ",
        "Num": "417",
        "Iso": "ISO 3166-2:KG",
        "ENName": "Kyrgyzstan",
        "CNName": "吉尔吉斯斯坦"
    },
    {
        "Code2": "GN",
        "Code3": "GIN",
        "Num": "324",
        "Iso": "ISO 3166-2:GN",
        "ENName": "Guinea",
        "CNName": "几内亚"
    },
    {
        "Code2": "GW",
        "Code3": "GNB",
        "Num": "624",
        "Iso": "ISO 3166-2:GW",
        "ENName": "Guinea-Bissau",
        "CNName": "几内亚比绍"
    },
    {
        "Code2": "CA",
        "Code3": "CAN",
        "Num": "124",
        "Iso": "ISO 3166-2:CA",
        "ENName": "Canada",
        "CNName": "加拿大"
    },
    {
        "Code2": "GH",
        "Code3": "GHA",
        "Num": "288",
        "Iso": "ISO 3166-2:GH",
        "ENName": "Ghana",
        "CNName": "加纳"
    },
    {
        "Code2": "GA",
        "Code3": "GAB",
        "Num": "266",
        "Iso": "ISO 3166-2:GA",
        "ENName": "Gabon",
        "CNName": "加蓬"
    },
    {
        "Code2": "KH",
        "Code3": "KHM",
        "Num": "116",
        "Iso": "ISO 3166-2:KH",
        "ENName": "Cambodia",
        "CNName": "柬埔寨"
    },
    {
        "Code2": "CZ",
        "Code3": "CZE",
        "Num": "203",
        "Iso": "ISO 3166-2:CZ",
        "ENName": "Czech Republic",
        "CNName": "捷克"
    },
    {
        "Code2": "ZW",
        "Code3": "ZWE",
        "Num": "716",
        "Iso": "ISO 3166-2:ZW",
        "ENName": "Zimbabwe",
        "CNName": "津巴布韦"
    },
    {
        "Code2": "CM",
        "Code3": "CMR",
        "Num": "120",
        "Iso": "ISO 3166-2:CM",
        "ENName": "Cameroon",
        "CNName": "喀麦隆"
    },
    {
        "Code2": "QA",
        "Code3": "QAT",
        "Num": "634",
        "Iso": "ISO 3166-2:QA",
        "ENName": "Qatar",
        "CNName": "卡塔尔"
    },
    {
        "Code2": "KY",
        "Code3": "CYM",
        "Num": "136",
        "Iso": "ISO 3166-2:KY",
        "ENName": "Cayman Islands",
        "CNName": "开曼群岛"
    },
    {
        "Code2": "CC",
        "Code3": "CCK",
        "Num": "166",
        "Iso": "ISO 3166-2:CC",
        "ENName": "Cocos (Keeling) Islands",
        "CNName": "科科斯群岛"
    },
    {
        "Code2": "KM",
        "Code3": "COM",
        "Num": "174",
        "Iso": "ISO 3166-2:KM",
        "ENName": "The Comoros",
        "CNName": "科摩罗"
    },
    {
        "Code2": "CI",
        "Code3": "CIV",
        "Num": "384",
        "Iso": "ISO 3166-2:CI",
        "ENName": "C?te d'Ivoire",
        "CNName": "科特迪瓦"
    },
    {
        "Code2": "KW",
        "Code3": "KWT",
        "Num": "414",
        "Iso": "ISO 3166-2:KW",
        "ENName": "Kuwait",
        "CNName": "科威特"
    },
    {
        "Code2": "HR",
        "Code3": "HRV",
        "Num": "191",
        "Iso": "ISO 3166-2:HR",
        "ENName": "Croatia",
        "CNName": "克罗地亚"
    },
    {
        "Code2": "KE",
        "Code3": "KEN",
        "Num": "404",
        "Iso": "ISO 3166-2:KE",
        "ENName": "Kenya",
        "CNName": "肯尼亚"
    },
    {
        "Code2": "CK",
        "Code3": "COK",
        "Num": "184",
        "Iso": "ISO 3166-2:CK",
        "ENName": "Cook Islands",
        "CNName": "库克群岛"
    },
    {
        "Code2": "LV",
        "Code3": "LVA",
        "Num": "428",
        "Iso": "ISO 3166-2:LV",
        "ENName": "Latvia",
        "CNName": "拉脱维亚"
    },
    {
        "Code2": "LS",
        "Code3": "LSO",
        "Num": "426",
        "Iso": "ISO 3166-2:LS",
        "ENName": "Lesotho",
        "CNName": "莱索托"
    },
    {
        "Code2": "LA",
        "Code3": "LAO",
        "Num": "418",
        "Iso": "ISO 3166-2:LA",
        "ENName": "Laos",
        "CNName": "老挝"
    },
    {
        "Code2": "LB",
        "Code3": "LBN",
        "Num": "422",
        "Iso": "ISO 3166-2:LB",
        "ENName": "Lebanon",
        "CNName": "黎巴嫩"
    },
    {
        "Code2": "LT",
        "Code3": "LTU",
        "Num": "440",
        "Iso": "ISO 3166-2:LT",
        "ENName": "Lithuania",
        "CNName": "立陶宛"
    },
    {
        "Code2": "LR",
        "Code3": "LBR",
        "Num": "430",
        "Iso": "ISO 3166-2:LR",
        "ENName": "Liberia",
        "CNName": "利比里亚"
    },
    {
        "Code2": "LY",
        "Code3": "LBY",
        "Num": "434",
        "Iso": "ISO 3166-2:LY",
        "ENName": "Libya",
        "CNName": "利比亚"
    },
    {
        "Code2": "LI",
        "Code3": "LIE",
        "Num": "438",
        "Iso": "ISO 3166-2:LI",
        "ENName": "Liechtenstein",
        "CNName": "列支敦士登"
    },
    {
        "Code2": "RE",
        "Code3": "REU",
        "Num": "638",
        "Iso": "ISO 3166-2:RE",
        "ENName": "Réunion",
        "CNName": "留尼汪"
    },
    {
        "Code2": "LU",
        "Code3": "LUX",
        "Num": "442",
        "Iso": "ISO 3166-2:LU",
        "ENName": "Luxembourg",
        "CNName": "卢森堡"
    },
    {
        "Code2": "RW",
        "Code3": "RWA",
        "Num": "646",
        "Iso": "ISO 3166-2:RW",
        "ENName": "Rwanda",
        "CNName": "卢旺达"
    },
    {
        "Code2": "RO",
        "Code3": "ROU",
        "Num": "642",
        "Iso": "ISO 3166-2:RO",
        "ENName": "Romania",
        "CNName": "罗马尼亚"
    },
    {
        "Code2": "MG",
        "Code3": "MDG",
        "Num": "450",
        "Iso": "ISO 3166-2:MG",
        "ENName": "Madagascar",
        "CNName": "马达加斯加"
    },
    {
        "Code2": "IM",
        "Code3": "IMN",
        "Num": "833",
        "Iso": "ISO 3166-2:IM",
        "ENName": "Isle of Man",
        "CNName": "马恩岛"
    },
    {
        "Code2": "MV",
        "Code3": "MDV",
        "Num": "462",
        "Iso": "ISO 3166-2:MV",
        "ENName": "Maldives",
        "CNName": "马尔代夫"
    },
    {
        "Code2": "FK",
        "Code3": "FLK",
        "Num": "238",
        "Iso": "ISO 3166-2:FK",
        "ENName": "Falkland Islands",
        "CNName": "马尔维纳斯群岛（ 福克兰）"
    },
    {
        "Code2": "MT",
        "Code3": "MLT",
        "Num": "470",
        "Iso": "ISO 3166-2:MT",
        "ENName": "Malta",
        "CNName": "马耳他"
    },
    {
        "Code2": "MW",
        "Code3": "MWI",
        "Num": "454",
        "Iso": "ISO 3166-2:MW",
        "ENName": "Malawi",
        "CNName": "马拉维"
    },
    {
        "Code2": "MY",
        "Code3": "MYS",
        "Num": "458",
        "Iso": "ISO 3166-2:MY",
        "ENName": "Malaysia",
        "CNName": "马来西亚"
    },
    {
        "Code2": "ML",
        "Code3": "MLI",
        "Num": "466",
        "Iso": "ISO 3166-2:ML",
        "ENName": "Mali",
        "CNName": "马里"
    },
    {
        "Code2": "MK",
        "Code3": "MKD",
        "Num": "807",
        "Iso": "ISO 3166-2:MK",
        "ENName": "Republic of Macedonia (FYROM)",
        "CNName": "马其顿"
    },
    {
        "Code2": "MH",
        "Code3": "MHL",
        "Num": "584",
        "Iso": "ISO 3166-2:MH",
        "ENName": "Marshall islands",
        "CNName": "马绍尔群岛"
    },
    {
        "Code2": "MQ",
        "Code3": "MTQ",
        "Num": "474",
        "Iso": "ISO 3166-2:MQ",
        "ENName": "Martinique",
        "CNName": "马提尼克"
    },
    {
        "Code2": "YT",
        "Code3": "MYT",
        "Num": "175",
        "Iso": "ISO 3166-2:YT",
        "ENName": "Mayotte",
        "CNName": "马约特"
    },
    {
        "Code2": "MU",
        "Code3": "MUS",
        "Num": "480",
        "Iso": "ISO 3166-2:MU",
        "ENName": "Mauritius",
        "CNName": "毛里求斯"
    },
    {
        "Code2": "MR",
        "Code3": "MRT",
        "Num": "478",
        "Iso": "ISO 3166-2:MR",
        "ENName": "Mauritania",
        "CNName": "毛里塔尼亚"
    },
    {
        "Code2": "US",
        "Code3": "USA",
        "Num": "840",
        "Iso": "ISO 3166-2:US",
        "ENName": "United States of America (USA)",
        "CNName": "美国"
    },
    {
        "Code2": "UM",
        "Code3": "UMI",
        "Num": "581",
        "Iso": "ISO 3166-2:UM",
        "ENName": "United States Minor Outlying Islands",
        "CNName": "美国本土外小岛屿"
    },
    {
        "Code2": "AS",
        "Code3": "ASM",
        "Num": "16",
        "Iso": "ISO 3166-2:AS",
        "ENName": "American Samoa",
        "CNName": "美属萨摩亚"
    },
    {
        "Code2": "VI",
        "Code3": "VIR",
        "Num": "850",
        "Iso": "ISO 3166-2:VI",
        "ENName": "United States Virgin Islands",
        "CNName": "美属维尔京群岛"
    },
    {
        "Code2": "MN",
        "Code3": "MNG",
        "Num": "496",
        "Iso": "ISO 3166-2:MN",
        "ENName": "Mongolia",
        "CNName": "蒙古国 蒙古"
    },
    {
        "Code2": "MS",
        "Code3": "MSR",
        "Num": "500",
        "Iso": "ISO 3166-2:MS",
        "ENName": "Montserrat",
        "CNName": "蒙塞拉特岛"
    },
    {
        "Code2": "BD",
        "Code3": "BGD",
        "Num": "50",
        "Iso": "ISO 3166-2:BD",
        "ENName": "Bangladesh",
        "CNName": "孟加拉"
    },
    {
        "Code2": "PE",
        "Code3": "PER",
        "Num": "604",
        "Iso": "ISO 3166-2:PE",
        "ENName": "Peru",
        "CNName": "秘鲁"
    },
    {
        "Code2": "FM",
        "Code3": "FSM",
        "Num": "583",
        "Iso": "ISO 3166-2:FM",
        "ENName": "Federated States of Micronesia",
        "CNName": "密克罗尼西亚联邦"
    },
    {
        "Code2": "MM",
        "Code3": "MMR",
        "Num": "104",
        "Iso": "ISO 3166-2:MM",
        "ENName": "Myanmar (Burma)",
        "CNName": "缅甸"
    },
    {
        "Code2": "MD",
        "Code3": "MDA",
        "Num": "498",
        "Iso": "ISO 3166-2:MD",
        "ENName": "Moldova",
        "CNName": "摩尔多瓦"
    },
    {
        "Code2": "MA",
        "Code3": "MAR",
        "Num": "504",
        "Iso": "ISO 3166-2:MA",
        "ENName": "Morocco",
        "CNName": "摩洛哥"
    },
    {
        "Code2": "MC",
        "Code3": "MCO",
        "Num": "492",
        "Iso": "ISO 3166-2:MC",
        "ENName": "Monaco",
        "CNName": "摩纳哥"
    },
    {
        "Code2": "MZ",
        "Code3": "MOZ",
        "Num": "508",
        "Iso": "ISO 3166-2:MZ",
        "ENName": "Mozambique",
        "CNName": "莫桑比克"
    },
    {
        "Code2": "MX",
        "Code3": "MEX",
        "Num": "484",
        "Iso": "ISO 3166-2:MX",
        "ENName": "Mexico",
        "CNName": "墨西哥"
    },
    {
        "Code2": "NA",
        "Code3": "NAM",
        "Num": "516",
        "Iso": "ISO 3166-2:NA",
        "ENName": "Namibia",
        "CNName": "纳米比亚"
    },
    {
        "Code2": "ZA",
        "Code3": "ZAF",
        "Num": "710",
        "Iso": "ISO 3166-2:ZA",
        "ENName": "South Africa",
        "CNName": "南非"
    },
    {
        "Code2": "AQ",
        "Code3": "ATA",
        "Num": "10",
        "Iso": "ISO 3166-2:AQ",
        "ENName": "Antarctica",
        "CNName": "南极洲"
    },
    {
        "Code2": "GS",
        "Code3": "SGS",
        "Num": "239",
        "Iso": "ISO 3166-2:GS",
        "ENName": "South Georgia and the South Sandwich Islands",
        "CNName": "南乔治亚岛和南桑威奇群岛"
    },
    {
        "Code2": "SS",
        "Code3": "SSD",
        "Num": "728",
        "Iso": "ISO 3166-2:SS",
        "ENName": "South Sudan",
        "CNName": "南苏丹"
    },
    {
        "Code2": "NR",
        "Code3": "NRU",
        "Num": "520",
        "Iso": "ISO 3166-2:NR",
        "ENName": "Nauru",
        "CNName": "瑙鲁"
    },
    {
        "Code2": "NP",
        "Code3": "NPL",
        "Num": "524",
        "Iso": "ISO 3166-2:NP",
        "ENName": "Nepal",
        "CNName": "尼泊尔"
    },
    {
        "Code2": "NI",
        "Code3": "NIC",
        "Num": "558",
        "Iso": "ISO 3166-2:NI",
        "ENName": "Nicaragua",
        "CNName": "尼加拉瓜"
    },
    {
        "Code2": "NE",
        "Code3": "NER",
        "Num": "562",
        "Iso": "ISO 3166-2:NE",
        "ENName": "Niger",
        "CNName": "尼日尔"
    },
    {
        "Code2": "NG",
        "Code3": "NGA",
        "Num": "566",
        "Iso": "ISO 3166-2:NG",
        "ENName": "Nigeria",
        "CNName": "尼日利亚"
    },
    {
        "Code2": "NU",
        "Code3": "NIU",
        "Num": "570",
        "Iso": "ISO 3166-2:NU",
        "ENName": "Niue",
        "CNName": "纽埃"
    },
    {
        "Code2": "NO",
        "Code3": "NOR",
        "Num": "578",
        "Iso": "ISO 3166-2:NO",
        "ENName": "Norway",
        "CNName": "挪威"
    },
    {
        "Code2": "NF",
        "Code3": "NFK",
        "Num": "574",
        "Iso": "ISO 3166-2:NF",
        "ENName": "Norfolk Island",
        "CNName": "诺福克岛"
    },
    {
        "Code2": "PW",
        "Code3": "PLW",
        "Num": "585",
        "Iso": "ISO 3166-2:PW",
        "ENName": "Palau",
        "CNName": "帕劳"
    },
    {
        "Code2": "PN",
        "Code3": "PCN",
        "Num": "612",
        "Iso": "ISO 3166-2:PN",
        "ENName": "Pitcairn Islands",
        "CNName": "皮特凯恩群岛"
    },
    {
        "Code2": "PT",
        "Code3": "PRT",
        "Num": "620",
        "Iso": "ISO 3166-2:PT",
        "ENName": "Portugal",
        "CNName": "葡萄牙"
    },
    {
        "Code2": "JP",
        "Code3": "JPN",
        "Num": "392",
        "Iso": "ISO 3166-2:JP",
        "ENName": "Japan",
        "CNName": "日本"
    },
    {
        "Code2": "SE",
        "Code3": "SWE",
        "Num": "752",
        "Iso": "ISO 3166-2:SE",
        "ENName": "Sweden",
        "CNName": "瑞典"
    },
    {
        "Code2": "CH",
        "Code3": "CHE",
        "Num": "756",
        "Iso": "ISO 3166-2:CH",
        "ENName": "Switzerland",
        "CNName": "瑞士"
    },
    {
        "Code2": "SV",
        "Code3": "SLV",
        "Num": "222",
        "Iso": "ISO 3166-2:SV",
        "ENName": "El Salvador",
        "CNName": "萨尔瓦多"
    },
    {
        "Code2": "WS",
        "Code3": "WSM",
        "Num": "882",
        "Iso": "ISO 3166-2:WS",
        "ENName": "Samoa",
        "CNName": "萨摩亚"
    },
    {
        "Code2": "RS",
        "Code3": "SRB",
        "Num": "688",
        "Iso": "ISO 3166-2:RS",
        "ENName": "Serbia",
        "CNName": "塞尔维亚"
    },
    {
        "Code2": "SL",
        "Code3": "SLE",
        "Num": "694",
        "Iso": "ISO 3166-2:SL",
        "ENName": "Sierra Leone",
        "CNName": "塞拉利昂"
    },
    {
        "Code2": "SN",
        "Code3": "SEN",
        "Num": "686",
        "Iso": "ISO 3166-2:SN",
        "ENName": "Senegal",
        "CNName": "塞内加尔"
    },
    {
        "Code2": "CY",
        "Code3": "CYP",
        "Num": "196",
        "Iso": "ISO 3166-2:CY",
        "ENName": "Cyprus",
        "CNName": "塞浦路斯"
    },
    {
        "Code2": "SC",
        "Code3": "SYC",
        "Num": "690",
        "Iso": "ISO 3166-2:SC",
        "ENName": "Seychelles",
        "CNName": "塞舌尔"
    },
    {
        "Code2": "SA",
        "Code3": "SAU",
        "Num": "682",
        "Iso": "ISO 3166-2:SA",
        "ENName": "Saudi Arabia",
        "CNName": "沙特阿拉伯"
    },
    {
        "Code2": "BL",
        "Code3": "BLM",
        "Num": "652",
        "Iso": "ISO 3166-2:BL",
        "ENName": "Saint Barthélemy",
        "CNName": "圣巴泰勒米岛"
    },
    {
        "Code2": "CX",
        "Code3": "CXR",
        "Num": "162",
        "Iso": "ISO 3166-2:CX",
        "ENName": "Christmas Island",
        "CNName": "圣诞岛"
    },
    {
        "Code2": "ST",
        "Code3": "STP",
        "Num": "678",
        "Iso": "ISO 3166-2:ST",
        "ENName": "Sao Tome & Principe",
        "CNName": "圣多美和普林西比"
    },
    {
        "Code2": "SH",
        "Code3": "SHN",
        "Num": "654",
        "Iso": "ISO 3166-2:SH",
        "ENName": "St. Helena & Dependencies",
        "CNName": "圣赫勒拿"
    },
    {
        "Code2": "KN",
        "Code3": "KNA",
        "Num": "659",
        "Iso": "ISO 3166-2:KN",
        "ENName": "St. Kitts & Nevis",
        "CNName": "圣基茨和尼维斯"
    },
    {
        "Code2": "LC",
        "Code3": "LCA",
        "Num": "662",
        "Iso": "ISO 3166-2:LC",
        "ENName": "St. Lucia",
        "CNName": "圣卢西亚"
    },
    {
        "Code2": "SM",
        "Code3": "SMR",
        "Num": "674",
        "Iso": "ISO 3166-2:SM",
        "ENName": "San Marino",
        "CNName": "圣马力诺"
    },
    {
        "Code2": "PM",
        "Code3": "SPM",
        "Num": "666",
        "Iso": "ISO 3166-2:PM",
        "ENName": "Saint-Pierre and Miquelon",
        "CNName": "圣皮埃尔和密克隆"
    },
    {
        "Code2": "VC",
        "Code3": "VCT",
        "Num": "670",
        "Iso": "ISO 3166-2:VC",
        "ENName": "St. Vincent & the Grenadines",
        "CNName": "圣文森特和格林纳丁斯"
    },
    {
        "Code2": "LK",
        "Code3": "LKA",
        "Num": "144",
        "Iso": "ISO 3166-2:LK",
        "ENName": "Sri Lanka",
        "CNName": "斯里兰卡"
    },
    {
        "Code2": "SK",
        "Code3": "SVK",
        "Num": "703",
        "Iso": "ISO 3166-2:SK",
        "ENName": "Slovakia",
        "CNName": "斯洛伐克"
    },
    {
        "Code2": "SI",
        "Code3": "SVN",
        "Num": "705",
        "Iso": "ISO 3166-2:SI",
        "ENName": "Slovenia",
        "CNName": "斯洛文尼亚"
    },
    {
        "Code2": "SJ",
        "Code3": "SJM",
        "Num": "744",
        "Iso": "ISO 3166-2:SJ",
        "ENName": "Template:Country data SJM Svalbard",
        "CNName": "斯瓦尔巴群岛和 扬马延岛"
    },
    {
        "Code2": "SZ",
        "Code3": "SWZ",
        "Num": "748",
        "Iso": "ISO 3166-2:SZ",
        "ENName": "Swaziland",
        "CNName": "斯威士兰"
    },
    {
        "Code2": "SD",
        "Code3": "SDN",
        "Num": "729",
        "Iso": "ISO 3166-2:SD",
        "ENName": "Sudan",
        "CNName": "苏丹"
    },
    {
        "Code2": "SR",
        "Code3": "SUR",
        "Num": "740",
        "Iso": "ISO 3166-2:SR",
        "ENName": "Suriname",
        "CNName": "苏里南"
    },
    {
        "Code2": "SB",
        "Code3": "SLB",
        "Num": "90",
        "Iso": "ISO 3166-2:SB",
        "ENName": "Solomon Islands",
        "CNName": "所罗门群岛"
    },
    {
        "Code2": "SO",
        "Code3": "SOM",
        "Num": "706",
        "Iso": "ISO 3166-2:SO",
        "ENName": "Somalia",
        "CNName": "索马里"
    },
    {
        "Code2": "TJ",
        "Code3": "TJK",
        "Num": "762",
        "Iso": "ISO 3166-2:TJ",
        "ENName": "Tajikistan",
        "CNName": "塔吉克斯坦"
    },
    {
        "Code2": "TH",
        "Code3": "THA",
        "Num": "764",
        "Iso": "ISO 3166-2:TH",
        "ENName": "Thailand",
        "CNName": "泰国"
    },
    {
        "Code2": "TZ",
        "Code3": "TZA",
        "Num": "834",
        "Iso": "ISO 3166-2:TZ",
        "ENName": "Tanzania",
        "CNName": "坦桑尼亚"
    },
    {
        "Code2": "TO",
        "Code3": "TON",
        "Num": "776",
        "Iso": "ISO 3166-2:TO",
        "ENName": "Tonga",
        "CNName": "汤加"
    },
    {
        "Code2": "TC",
        "Code3": "TCA",
        "Num": "796",
        "Iso": "ISO 3166-2:TC",
        "ENName": "Turks & Caicos Islands",
        "CNName": "特克斯和凯科斯群岛"
    },
    {
        "Code2": "TT",
        "Code3": "TTO",
        "Num": "780",
        "Iso": "ISO 3166-2:TT",
        "ENName": "Trinidad & Tobago",
        "CNName": "特立尼达和多巴哥"
    },
    {
        "Code2": "TN",
        "Code3": "TUN",
        "Num": "788",
        "Iso": "ISO 3166-2:TN",
        "ENName": "Tunisia",
        "CNName": "突尼斯"
    },
    {
        "Code2": "TV",
        "Code3": "TUV",
        "Num": "798",
        "Iso": "ISO 3166-2:TV",
        "ENName": "Tuvalu",
        "CNName": "图瓦卢"
    },
    {
        "Code2": "TR",
        "Code3": "TUR",
        "Num": "792",
        "Iso": "ISO 3166-2:TR",
        "ENName": "Turkey",
        "CNName": "土耳其"
    },
    {
        "Code2": "TM",
        "Code3": "TKM",
        "Num": "795",
        "Iso": "ISO 3166-2:TM",
        "ENName": "Turkmenistan",
        "CNName": "土库曼斯坦"
    },
    {
        "Code2": "TK",
        "Code3": "TKL",
        "Num": "772",
        "Iso": "ISO 3166-2:TK",
        "ENName": "Tokelau",
        "CNName": "托克劳"
    },
    {
        "Code2": "WF",
        "Code3": "WLF",
        "Num": "876",
        "Iso": "ISO 3166-2:WF",
        "ENName": "Wallis and Futuna",
        "CNName": "瓦利斯和富图纳"
    },
    {
        "Code2": "VU",
        "Code3": "VUT",
        "Num": "548",
        "Iso": "ISO 3166-2:VU",
        "ENName": "Vanuatu",
        "CNName": "瓦努阿图"
    },
    {
        "Code2": "GT",
        "Code3": "GTM",
        "Num": "320",
        "Iso": "ISO 3166-2:GT",
        "ENName": "Guatemala",
        "CNName": "危地马拉"
    },
    {
        "Code2": "VE",
        "Code3": "VEN",
        "Num": "862",
        "Iso": "ISO 3166-2:VE",
        "ENName": "Venezuela",
        "CNName": "委内瑞拉"
    },
    {
        "Code2": "BN",
        "Code3": "BRN",
        "Num": "96",
        "Iso": "ISO 3166-2:BN",
        "ENName": "Brunei",
        "CNName": "文莱"
    },
    {
        "Code2": "UG",
        "Code3": "UGA",
        "Num": "800",
        "Iso": "ISO 3166-2:UG",
        "ENName": "Uganda",
        "CNName": "乌干达"
    },
    {
        "Code2": "UA",
        "Code3": "UKR",
        "Num": "804",
        "Iso": "ISO 3166-2:UA",
        "ENName": "Ukraine",
        "CNName": "乌克兰"
    },
    {
        "Code2": "UY",
        "Code3": "URY",
        "Num": "858",
        "Iso": "ISO 3166-2:UY",
        "ENName": "Uruguay",
        "CNName": "乌拉圭"
    },
    {
        "Code2": "UZ",
        "Code3": "UZB",
        "Num": "860",
        "Iso": "ISO 3166-2:UZ",
        "ENName": "Uzbekistan",
        "CNName": "乌兹别克斯坦"
    },
    {
        "Code2": "ES",
        "Code3": "ESP",
        "Num": "724",
        "Iso": "ISO 3166-2:ES",
        "ENName": "Spain",
        "CNName": "西班牙"
    },
    {
        "Code2": "EH",
        "Code3": "ESH",
        "Num": "732",
        "Iso": "ISO 3166-2:EH",
        "ENName": "Western Sahara",
        "CNName": "西撒哈拉"
    },
    {
        "Code2": "GR",
        "Code3": "GRC",
        "Num": "300",
        "Iso": "ISO 3166-2:GR",
        "ENName": "Greece",
        "CNName": "希腊"
    },
    {
        "Code2": "SG",
        "Code3": "SGP",
        "Num": "702",
        "Iso": "ISO 3166-2:SG",
        "ENName": "Singapore",
        "CNName": "新加坡"
    },
    {
        "Code2": "NC",
        "Code3": "NCL",
        "Num": "540",
        "Iso": "ISO 3166-2:NC",
        "ENName": "New Caledonia",
        "CNName": "新喀里多尼亚"
    },
    {
        "Code2": "NZ",
        "Code3": "NZL",
        "Num": "554",
        "Iso": "ISO 3166-2:NZ",
        "ENName": "New Zealand",
        "CNName": "新西兰"
    },
    {
        "Code2": "HU",
        "Code3": "HUN",
        "Num": "348",
        "Iso": "ISO 3166-2:HU",
        "ENName": "Hungary",
        "CNName": "匈牙利"
    },
    {
        "Code2": "SY",
        "Code3": "SYR",
        "Num": "760",
        "Iso": "ISO 3166-2:SY",
        "ENName": "Syria",
        "CNName": "叙利亚"
    },
    {
        "Code2": "JM",
        "Code3": "JAM",
        "Num": "388",
        "Iso": "ISO 3166-2:JM",
        "ENName": "Jamaica",
        "CNName": "牙买加"
    },
    {
        "Code2": "AM",
        "Code3": "ARM",
        "Num": "51",
        "Iso": "ISO 3166-2:AM",
        "ENName": "Armenia",
        "CNName": "亚美尼亚"
    },
    {
        "Code2": "YE",
        "Code3": "YEM",
        "Num": "887",
        "Iso": "ISO 3166-2:YE",
        "ENName": "Yemen",
        "CNName": "也门"
    },
    {
        "Code2": "IQ",
        "Code3": "IRQ",
        "Num": "368",
        "Iso": "ISO 3166-2:IQ",
        "ENName": "Iraq",
        "CNName": "伊拉克"
    },
    {
        "Code2": "IR",
        "Code3": "IRN",
        "Num": "364",
        "Iso": "ISO 3166-2:IR",
        "ENName": "Iran",
        "CNName": "伊朗"
    },
    {
        "Code2": "IL",
        "Code3": "ISR",
        "Num": "376",
        "Iso": "ISO 3166-2:IL",
        "ENName": "Israel",
        "CNName": "以色列"
    },
    {
        "Code2": "IT",
        "Code3": "ITA",
        "Num": "380",
        "Iso": "ISO 3166-2:IT",
        "ENName": "Italy",
        "CNName": "意大利"
    },
    {
        "Code2": "IN",
        "Code3": "IND",
        "Num": "356",
        "Iso": "ISO 3166-2:IN",
        "ENName": "India",
        "CNName": "印度"
    },
    {
        "Code2": "ID",
        "Code3": "IDN",
        "Num": "360",
        "Iso": "ISO 3166-2:ID",
        "ENName": "Indonesia",
        "CNName": "印尼"
    },
    {
        "Code2": "GB",
        "Code3": "GBR",
        "Num": "826",
        "Iso": "ISO 3166-2:GB",
        "ENName": "Great Britain (United Kingdom; England)",
        "CNName": "英国"
    },
    {
        "Code2": "VG",
        "Code3": "VGB",
        "Num": "92",
        "Iso": "ISO 3166-2:VG",
        "ENName": "British Virgin Islands",
        "CNName": "英属维尔京群岛"
    },
    {
        "Code2": "IO",
        "Code3": "IOT",
        "Num": "86",
        "Iso": "ISO 3166-2:IO",
        "ENName": "British Indian Ocean Territory",
        "CNName": "英属印度洋领地"
    },
    {
        "Code2": "JO",
        "Code3": "JOR",
        "Num": "400",
        "Iso": "ISO 3166-2:JO",
        "ENName": "Jordan",
        "CNName": "约旦"
    },
    {
        "Code2": "VN",
        "Code3": "VNM",
        "Num": "704",
        "Iso": "ISO 3166-2:VN",
        "ENName": "Vietnam",
        "CNName": "越南"
    },
    {
        "Code2": "ZM",
        "Code3": "ZMB",
        "Num": "894",
        "Iso": "ISO 3166-2:ZM",
        "ENName": "Zambia",
        "CNName": "赞比亚"
    },
    {
        "Code2": "JE",
        "Code3": "JEY",
        "Num": "832",
        "Iso": "ISO 3166-2:JE",
        "ENName": "Jersey",
        "CNName": "泽西岛"
    },
    {
        "Code2": "TD",
        "Code3": "TCD",
        "Num": "148",
        "Iso": "ISO 3166-2:TD",
        "ENName": "Chad",
        "CNName": "乍得"
    },
    {
        "Code2": "GI",
        "Code3": "GIB",
        "Num": "292",
        "Iso": "ISO 3166-2:GI",
        "ENName": "Gibraltar",
        "CNName": "直布罗陀"
    },
    {
        "Code2": "CL",
        "Code3": "CHL",
        "Num": "152",
        "Iso": "ISO 3166-2:CL",
        "ENName": "Chile",
        "CNName": "智利"
    },
    {
        "Code2": "CF",
        "Code3": "CAF",
        "Num": "140",
        "Iso": "ISO 3166-2:CF",
        "ENName": "Central African Republic",
        "CNName": "中非"
    },
    {
        "Code2": "MO",
        "Code3": "MAC",
        "Num": "446",
        "Iso": "ISO 3166-2:MO",
        "ENName": "Macao",
        "CNName": "中国澳门"
    },
    {
        "Code2": "CN",
        "Code3": "CHN",
        "Num": "156",
        "Iso": "ISO 3166-2:CN",
        "ENName": "China",
        "CNName": "中国大陆"
    },
    {
        "Code2": "TW",
        "Code3": "TWN",
        "Num": "158",
        "Iso": "ISO 3166-2:TW",
        "ENName": "Taiwan",
        "CNName": "中国台湾"
    },
    {
        "Code2": "HK",
        "Code3": "HKG",
        "Num": "344",
        "Iso": "ISO 3166-2:HK",
        "ENName": "Hong Kong",
        "CNName": "中国香港"
    },

]

var freCountry = [
    {
        "Code2": "CN",
        "Code3": "CHN",
        "Num": "156",
        "Iso": "ISO 3166-2:CN",
        "ENName": "China",
        "CNName": "中国大陆"
    },
    {
        "Code2": "HK",
        "Code3": "HKG",
        "Num": "344",
        "Iso": "ISO 3166-2:HK",
        "ENName": "Hong Kong",
        "CNName": "中国香港"
    },
    {
        "Code2": "TW",
        "Code3": "TWN",
        "Num": "158",
        "Iso": "ISO 3166-2:TW",
        "ENName": "Taiwan",
        "CNName": "中国台湾"
    },
    {
        "Code2": "US",
        "Code3": "USA",
        "Num": "840",
        "Iso": "ISO 3166-2:US",
        "ENName": "United States of America (USA)",
        "CNName": "美国"
    },
    {
        "Code2": "JP",
        "Code3": "JPN",
        "Num": "392",
        "Iso": "ISO 3166-2:JP",
        "ENName": "Japan",
        "CNName": "日本"
    },
    {
        "Code2": "CA",
        "Code3": "CAN",
        "Num": "124",
        "Iso": "ISO 3166-2:CA",
        "ENName": "Canada",
        "CNName": "加拿大"
    },
    {
        "Code2": "AU",
        "Code3": "AUS",
        "Num": "36",
        "Iso": "ISO 3166-2:AU",
        "ENName": "Australia",
        "CNName": "澳大利亚"
    },
    {
        "Code2": "KR",
        "Code3": "KOR",
        "Num": "410",
        "Iso": "ISO 3166-2:KR",
        "ENName": "South Korea",
        "CNName": "韩国 南朝鲜"
    },
    {
        "Code2": "MO",
        "Code3": "MAC",
        "Num": "446",
        "Iso": "ISO 3166-2:MO",
        "ENName": "Macao",
        "CNName": "中国澳门"
    },
    {
        "Code2": "SG",
        "Code3": "SGP",
        "Num": "702",
        "Iso": "ISO 3166-2:SG",
        "ENName": "Singapore",
        "CNName": "新加坡"
    },
    {
        "Code2": "GB",
        "Code3": "GBR",
        "Num": "826",
        "Iso": "ISO 3166-2:GB",
        "ENName": "Great Britain (United Kingdom; England)",
        "CNName": "英国"
    },
    {
        "Code2": "SE",
        "Code3": "SWE",
        "Num": "752",
        "Iso": "ISO 3166-2:SE",
        "ENName": "Sweden",
        "CNName": "瑞典"
    },
]

module.exports = {
    country: country,
    freCountry: freCountry
}


// WEBPACK FOOTER //
// ./src/common/country.js